<tec-modal [isVisible]="true" [title]="'ACTIVITY.DETAIL.TITLE' | translate" (closeEvent)="closeModal()">
	<ng-container body>
		@if (alertError) {
		<tec-alert [msg]="alertError" status="error" (closeAlert)="alertError = ''" />
		}

		<div class="grid grid-e3">
			<tec-info-group [label]="'ACTIVITY.DETAIL.USER' | translate">
				<span>{{ userLabel }}</span>
			</tec-info-group>
			<tec-info-group [label]="'ACTIVITY.DETAIL.IP' | translate">
				<span>{{ detail?.ip || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
			</tec-info-group>
			<tec-info-group [label]="'ACTIVITY.DETAIL.DEVICE' | translate">
				<span>{{ detail?.device || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
			</tec-info-group>
		</div>

		<div class="grid grid-e3">
			<tec-info-group [label]="'ACTIVITY.DETAIL.BROWSER' | translate">
				<span>{{ detail?.explorer || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
			</tec-info-group>
			<tec-info-group [label]="'ACTIVITY.DETAIL.DATE' | translate">
				<span>{{ formattedOccurredAt }}</span>
			</tec-info-group>
		</div>
	</ng-container>
</tec-modal>
